export default __webpack_public_path__ + "static/media/large-birthday.2df731bc.jpg";